import { Dispatch } from "react";

type BinderFactory<TAction, TResult> = (dispatch: Dispatch<TAction>) => TResult;

type ActionBinder = <TState, TAction, TResult>(
  factory: BinderFactory<TAction, TResult>,
) => (args: [TState, Dispatch<TAction>]) => [TState, TResult];

const bindActions: ActionBinder =
  (factory) =>
  ([state, dispatch]) => [state, factory(dispatch)];

export default bindActions;
